
import {
  Component,
  Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import OperationComponentMixin from '@/mixins/OperationComponentMixin.vue';

moment.locale('it');

@Component
export default class OperationSiteInspection extends Mixins(OperationComponentMixin) {
  get siteInspectionDate(): string | null {
    return this.operationChild
      && this.operationChild.siteInspectionDate
      && moment(this.operationChild.siteInspectionDate).isValid()
      ? moment(this.operationChild.siteInspectionDate).format('L')
      : null;
  }

  get siteInspectionResultNotes(): string | null {
    return this.operationChild?.siteInspectionResultNotes || null;
  }

  get hasExtraCosts(): boolean {
    return this.operationChild?.hasExtraCosts === true;
  }

  get tooltipText() {
    let result = '';

    result = this.siteInspectionDate
      ? 'Data del sopralluogo'
      : "In attesa che venga fissato l'appuntamento per il sopralluogo";

    if (this.siteInspectionResultNotes
      && this.isCurrentUserOwnerOrRequester
      && this.hasPermission('taska.siteInspectionResultNotes.show')
    ) result += ` - ${this.siteInspectionResultNotes}`;

    if (this.hasExtraCosts) result += ' (previsti extra-costi)';

    return result;
  }

  get firstColumnClass(): string {
    // Se il task A è completo o fallito, ritorna il suo stato (verde, rosso)
    // if (this.taskStatus('A')) return this.taskStatus('A') || '';
    if (this.operationChild?.flatTasks.includes('A=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('A=x')) return 'completed';
    if (this.operationChild?.flatTasks.includes('A=e')) return 'error';

    // Se il task A ancora non è completo o fallito,
    // e il task S è completato, ritorna giallo.
    // if (this.taskStatus('S') && this.taskStatus('S') === 'completed') return 'selected';
    if (this.operationChild?.flatTasks.includes('S=c')) return 'selected';

    // Se il task A ancora non è completo o fallito,
    // e il task S non è completato,
    // ritorna lo stato del task S (rosso o bianco)
    if (this.operationChild?.flatTasks.includes('S=c')) return 'completed';
    if (this.operationChild?.flatTasks.includes('S=e')) return 'error';
    return '';
  }

  onEdit() {
    console.log('OperationSiteInspection: onEdit()'); // eslint-disable-line no-console

    if (!this.operationChild?.flatTasks.includes('S=c')) return this.$emit('editS');
    return this.$emit('editA');
  }
}
